import { ICurrencyData } from "@biz/definitions/PriceDefinitions";

function create(id: string, sign: string, factor: number, decimalPlaces: number, smallestUnit: number): ICurrencyData {
  const cd: ICurrencyData = {
    id,
    sign,
    factor,
    decimalPlaces,
    smallestUnit,
  };
  return cd;
}

export const CurrencyData = {
  EURO: create("EUR", "€", 1.0, 2, 0.01),
  create,
};
